var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "d-flex flex-column",
      attrs: {
        height: "100%"
      }
    },
    [
      _c("gg-card-header", [_vm._v(" I Need Help ")]),
      _c("gg-card-text", [
        _vm._v(
          " If you need assistance, click the button below to get in touch with our Support Team. Our team will assist with resolving this alert and explaining your options. "
        )
      ]),
      _c(
        "v-card-actions",
        {
          staticClass: "justify-end mt-auto pa-4"
        },
        [
          _c(
            "gg-btn",
            {
              attrs: {
                to: {
                  name: "support_ticketnew",
                  query: {
                    d: "Support",
                    s: _vm.alert.serviceID,
                    sbj: _vm.subject
                  }
                }
              }
            },
            [_vm._v(" Open Ticket ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }